// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isAfter, isPast, isValid, parse } from "date-fns";
import MaskedInput from "../MaskedInput";
import { noop } from "../util";

function BirthdateInput({ value, onChange, onValidityChange, ...props }) {
  const requiredMessage = "Campo obrigatório. Digite sua data de nascimento";
  const incompleteDateMessage = "Digite a data completa no formato DD/MM/AAAA";
  const invalidDateMessage = "Data inválida. Digite sua data de nascimento";

  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [helperText, setHelperText] = useState(requiredMessage);

  const dateFormat = "dd/MM/yyyy";
  const formatChars = {
    1: "[01]",
    2: "[12]",
    3: "[0-3]",
    9: "[0-9]",
  };

  const validateInput = (dateString) => {
    const date = parse(dateString, dateFormat, new Date());
    // Kane Tanaka, as of March 22, 2021  https://en.wikipedia.org/wiki/List_of_the_verified_oldest_people
    const oldestLivingPersonBirthdate = new Date(1903, 0, 2);
    return {
      valid: isValid(date),
      inRange:
        isValid(date) &&
        isPast(date) &&
        isAfter(date, oldestLivingPersonBirthdate),
    };
  };

  useEffect(() => {
    const { inRange, valid } = validateInput(value);
    setError(!valid || !inRange);
    setEmpty(value.length === 0);

    if (!inRange) {
      setHelperText(invalidDateMessage);
    }
    if (!valid) {
      setHelperText(incompleteDateMessage);
    }
    if (empty) {
      setHelperText(requiredMessage);
    }

    onValidityChange(valid && inRange);
  }, [empty, onValidityChange, value]);

  return (
    <MaskedInput
      value={value}
      onChange={onChange}
      onBlur={() => setTouched(true)}
      mask="39/19/2999"
      formatChars={formatChars}
      label="Data de nascimento"
      placeholder="DD/MM/AAAA"
      error={touched && error}
      helperText={touched && error ? helperText : ""}
      autoComplete="bday"
      inputProps={{ inputMode: "decimal" }}
      {...props}
    />
  );
}

BirthdateInput.defaultProps = {
  onValidityChange: noop,
};

BirthdateInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func,
};

export default BirthdateInput;
